import React from "react";
import "../../assests/css/generals/SpinnerLoading.css";

const LoadingSpinner = ({ fullScreen = true }) => {
  return (
    <div className={fullScreen ? "spinner-overlay" : "spinner-inline"}>
      <div className="spinner-container">
        <div className="spinner-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p className="spinner-text">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;